import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { NewSessionModalProvider } from './context/NewSessionModalContext';
import App from './App';
import './index.css';
import './mobile.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <AuthProvider>
      <NewSessionModalProvider>
        <App />
      </NewSessionModalProvider>
    </AuthProvider>
  </BrowserRouter>
);
